// extracted by mini-css-extract-plugin
module.exports = {"section":"Step2_section__nVzMF","image":"Step2_image__1Pd64","desc":"Step2_desc__2_rG3"};